import * as types from '../mutation-types'
import {getField, updateField} from "vuex-map-fields";
import {getFormInformation, getFormFiles, getBachelorFOIs,getMasterFOIs} from '~/services/detailsService'
import formDependencies from '~/util/form-dependencies';

// state
export const state = {
	form: null,
	files: null,
	record: null
}

// getters
export const getters = {
	getField,

	isBachelor: state => {
		return getBachelorFOIs()
			.indexOf(state.form.fieldOfInterest) !== -1
	},

	isMaster: state => {
		return getMasterFOIs()
			.indexOf(state.form.fieldOfInterest) !== -1
	},
	fallSemester2026: state => {
		return state.form.semesterApplied == 'Fall 2026'
	},
	foiLabel: state => {
		const foiLabels = formDependencies.fieldsOfInterest[state.form.gender];
		return foiLabels.find(a => a.name ===  state.form.fieldOfInterest).label;
	},

	isBABA: state => {
		return state.form.fieldOfInterest == 'BA in Business Administration'
	},

	isBSA: state => {
		return state.form.fieldOfInterest == 'BS in Accounting'
	},

	isBSBAA: state => {
		return state.form.fieldOfInterest == 'BS in Business Admin with Accounting Specialization'
	},

	isBAED: state => {
		return state.form.fieldOfInterest == 'BA in Education and Special Education'
	},

	isBAPsyc: state => {
		return state.form.fieldOfInterest.startsWith('BA in Psychology')
	},

	isMSLP: state => {
		return state.form.fieldOfInterest == 'Master of Speech-Language Pathology'
	},
	isMSAct: state => {
		return state.form.fieldOfInterest == 'MS in Accounting'
	},
	isSLP : state => {
		return state.form.fieldOfInterest == 'Speech (SLP) Prereq Courses'
}	,
	isMESED: state => {
		return state.form.fieldOfInterest == 'MS in Education and Special Education' && state.form.semesterApplied == 'Post Pesach 2021'
	},

	isMSED: state => {
		return state.form.fieldOfInterest == 'MS in Education and Special Education'
	},

	isMSCybSec: state => {
		return state.form.fieldOfInterest == "Master in Cyber Security"
	},

	isMBARE: state => {
		return state.form.fieldOfInterest == 'MBA'
	},

	isBPSMSW: state => {
		return state.form.fieldOfInterest == 'Bachelor of Professional Studies-MSW'
	},
	isBLS: state => {
		return state.form.fieldOfInterest == 'Bachelor of Science in Legal Studies'
	},

	isMSW: state => {
		return state.form.fieldOfInterest == 'MSW in Social Work'
	},
	isMNutr: state => {
    		return state.form.fieldOfInterest == 'MS in Nutrition'
    	},

	isNutrPrereq: state => {
    		return state.form.fieldOfInterest == 'Nutrition Prereq Courses'
    	},
    		isOTD: state => {
            		return state.form.fieldOfInterest == 'Occupational Therapy Doctorate (OTD)'
            	},
	isDrCP: state => {
            		return state.form.fieldOfInterest == 'Doctorate in Counseling Psychology'
            	},
	isOTDPrereq: state => {
		return state.form.fieldOfInterest == 'OT Prereq Courses'
	},
	isMPS: state => {
            		return state.form.fieldOfInterest == 'MPS in Applied Behavior Analysis (ABA) – LBA & BCBA'
            	},
	isABA: state => {
           		return state.form.fieldOfInterest == 'Advance Certificate in Applied Behavior Analysis (ABA) – LBA & BCBA'
         	},


	selectedFOI: state => {
		return state.form.fieldOfInterest;
	},


	// not in use
	// forCollegeMountSaintVincent: state => {
	// 	return (state.form.fieldOfInterest == 'BA in Psychology' && state.form.campusLocation == "Lakewood") ||
	// 		(state.form.fieldOfInterest == "BA in Psychology-Speech Track" && state.form.campusLocation == "Lakewood") ||
	// 		( state.form.fieldOfInterest == 'Bachelor in Business Administration' && state.form.campusLocation != "Online") ||
	// 		(state.form.fieldOfInterest == 'BS in Accounting' && state.form.campusLocation == "Lakewood") ||
	// 		state.form.fieldOfInterest == 'Bachelor of Professional Studies-MSW'
	// },
	//
	// forSaintPetersUniversity: state => {
	// 	return (state.form.fieldOfInterest == 'BA in Psychology' && state.form.campusLocation != "Lakewood") ||
	// 		(state.form.fieldOfInterest == "BA in Psychology-Speech Track" && state.form.campusLocation != "Lakewood") ||
	// 		(state.form.fieldOfInterest == "Bachelor in Business Administration" && state.form.campusLocation == "Online") ||
	// 		(state.form.fieldOfInterest == 'BS in Accounting' && state.form.campusLocation != "Lakewood") ||
	// 		state.form.fieldOfInterest == 'BA in Education and Special Education'
	// }
}

// mutations
export const mutations = {
	[types.SET_FORM_INFORMATION](state, record) {
		state.form = getFormInformation(record)
		state.record = record
	},

	[types.SET_FORM_FILES](state, record) {
		state.files = getFormFiles(record)
	},

	[types.SET_FORM_FILE](state, data) {
		state.files[data.field].file = data.file
		state.files[data.field].name = data.name
		state.files[data.field].errors = null
		//state.files[data.field].validated = false
	},

	[types.SET_FORM_FILE_ERRORS](state, { field, errors }) {
		state.files[field].errors = errors
	},

	[types.MARK_FORM_FILE_AS_VALIDATED](state, field) {
		state.files[field].errors = null
		state.files[field].validated = true
	},

	[types.MARK_FORM_FILE_AS_INVALID](state, field) {
		state.files[field].validated = false
	},
}

// actions
export const actions = {
	setFormInformation({commit}, record) {
		commit(types.SET_FORM_INFORMATION, record)
		commit(types.SET_FORM_FILES, record)
	},

	updateFormField({commit}, { field, file, name }) {
		commit(types.SET_FORM_FILE, {field, file, name})
	},

	setFormFieldErrors({commit}, { field, errors }) {
		commit(types.SET_FORM_FILE_ERRORS, { field, errors })
	},

	markFormFieldAsValidated({commit}, field) {
		commit(types.MARK_FORM_FILE_AS_VALIDATED, field)
	},

	markFormFieldAsInvalid({commit}, field) {
		commit(types.MARK_FORM_FILE_AS_INVALID, field)
	}
}



// WEBPACK FOOTER //
// ./resources/js/store/modules/details.js